module.exports = __webpack_public_path__ + "img/Local-Clips-Option-1.40c2b149.png";